import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"; // Added

// Import translation files
import enTranslation from "./locales/en.json";
import alTranslation from "./locales/al.json";
import frTranslation from "./locales/fr.json";
import deTranslation from "./locales/de.json";

const resources = {
  al: {
    translation: alTranslation,
  },
  en: {
    translation: enTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  de: {
    translation: deTranslation,
  },
};

i18n
  .use(LanguageDetector) // Added: automatically detects user language
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en", // Added: fallback language
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"], // Added: check localStorage first, then browser
      caches: ["localStorage"], // Added: store language preference
    },
  });

export default i18n;
